
import React from 'react';
import { ServiceDefinition, Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface ServicesModalProps {
  language: Language;
  selectedService: ServiceDefinition;
  onClose: () => void;
  onRunService: (service: ServiceDefinition) => void;
  onAutomateService: (service: ServiceDefinition) => void;
}

const ServicesModal: React.FC<ServicesModalProps> = ({ 
  language, selectedService, onClose, onRunService, onAutomateService 
}) => {
  const t = TRANSLATIONS[language];

  return (
    <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md" onClick={onClose} />
      <div className="relative w-full max-w-2xl bg-white dark:bg-[#111115] rounded-[32px] shadow-2xl border border-white/10 overflow-hidden animate-in zoom-in-95 duration-300 max-h-[90vh] overflow-y-auto custom-scrollbar">
        <div className={`h-32 bg-gradient-to-r ${selectedService.color} relative shrink-0`}>
           <button onClick={onClose} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-black/20 text-white flex items-center justify-center hover:bg-black/40 transition-all z-10">
             <i className="fas fa-times"></i>
           </button>
           <div className="absolute -bottom-8 left-8 w-16 h-16 rounded-2xl bg-white dark:bg-[#1a1a20] flex items-center justify-center text-3xl shadow-lg">
              <i className={`fas ${selectedService.icon} text-slate-800 dark:text-white`}></i>
           </div>
        </div>

        <div className="pt-10 px-8 pb-8">
           <div className="flex justify-between items-start mb-4">
             <div>
               <h2 className="text-2xl font-black text-slate-800 dark:text-white">{selectedService.title}</h2>
               <span className="text-xs font-bold text-slate-400 uppercase tracking-widest">{selectedService.category}</span>
             </div>
             {selectedService.isPro && (
               <span className="bg-amber-500/10 text-amber-500 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider border border-amber-500/20">
                 <i className="fas fa-crown mr-1"></i> {t.proOnly}
               </span>
             )}
           </div>

           <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed mb-6">
             {selectedService.description}
           </p>

           <div className="flex flex-col sm:flex-row gap-3">
             <button 
               onClick={() => onRunService(selectedService)}
               className="flex-1 py-3.5 rounded-xl bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-black text-xs shadow-lg active:scale-95 transition-all flex items-center justify-center gap-2"
             >
               <i className="fas fa-comment-dots"></i> {t.runLive}
             </button>
             <button 
               onClick={() => onAutomateService(selectedService)}
               className="flex-1 py-3.5 rounded-xl bg-emerald-500 text-white font-black text-xs shadow-lg shadow-emerald-500/20 active:scale-95 transition-all flex items-center justify-center gap-2"
             >
               <i className="fas fa-bolt"></i> {t.buildFlow}
             </button>
           </div>
        </div>
      </div>
    </div>
  );
};
export default ServicesModal;
